module.exports = __webpack_public_path__ + "static/hudl@2x-3e0f04c3e89b8352d67afa4b8c732e61.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/hudl@2x.png
// module id = 2690
// module chunks = 157636680307020